import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

export interface AddSektionData {
  gebaeudeId: string;
}

@Component({
  selector: 'app-add-sektion-dialog',
  templateUrl: './add-sektion-dialog.component.html',
  styleUrls: ['./add-sektion-dialog.component.css'],
})
export class AddSektionDialogComponent implements OnInit {
  frmSektion: UntypedFormGroup;
  gebaeudeId: string;

  constructor(
    public dialogRef: MatDialogRef<AddSektionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddSektionData,
    private _fb: UntypedFormBuilder
  ) {
    this.gebaeudeId = data.gebaeudeId;

    this.frmSektion = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      gebaeude_id: [this.gebaeudeId]
    });
  }

  ngOnInit() {
    // Form is already initialized in constructor
  }

  onConfirm(): void {
    if (this.frmSektion.valid) {
      this.dialogRef.close({ 
        event: 'create', 
        data: this.frmSektion.value 
      });
    }
  }

  onDismiss(): void {
    this.dialogRef.close({ event: 'cancel' });
  }
}
